import axios from "axios";

const EmployeeRegisterService = {

  // ── POST APIs ──────────────────────────────────────────────────────────────

  async postEmployeeDetails(data) {
    try {
      const response = await axios.post("/UserRegister/PostEmployeeDetails", data);
      console.log("API Response:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error Inserting Employee Details", error);
      throw error;
    }
  },

  async postEmployeeQualifications(data) {
    try {
      const response = await axios.post("/UserRegister/PostEmployeeQualifications", data);
      console.log("API Response:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error Inserting Employee Qualifications", error);
      throw error;
    }
  },

  async postEmployeeDependents(data) {
    try {
      const response = await axios.post("/UserRegister/PostEmployeeDependents", data);
      console.log("API Response:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error Inserting Employee Dependents", error);
      throw error;
    }
  },

  async postPreviousEmployement(data) {
    try {
      const response = await axios.post("/UserRegister/PostPreviousEmployment", data);
      console.log("API Response:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error Inserting Previous Employments", error);
      throw error;
    }
  },

  async postWorkplaceRelationships(data) {
    try {
      const response = await axios.post("/UserRegister/PostWorkplaceRelationships", data);
      console.log("API Response:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error Inserting Workplace Relationships", error);
      throw error;
    }
  },

  // ── GET APIs ───────────────────────────────────────────────────────────────

  // Fetches all employees for the session panel
  async getAllEmployees() {
    try {
      const response = await axios.get("/UserDetails/GetEmployeeDetailsByUser");
      console.log("getAllEmployees Response:", response.data);
      return response.data;
    } catch (error) {
      console.error("Error Fetching all Employees", error);
      throw error;
    }
  },

  // Fetches ONE employee by serviceNo — param name must match what backend expects
  async getEmployeeByServiceNo(serviceNo) {
    try {
      const response = await axios.get("/UserDetails/GetEmployeeDetailsByUser", {
        params: { serviceNo: serviceNo },
      });
      console.log("getEmployeeByServiceNo RAW RESPONSE:", JSON.stringify(response.data));
      return response.data;
    } catch (error) {
      console.error("Error Fetching Employee by Service No", error);
      throw error;
    }
  },

  // FIXED: /UserDetails/ not /UserRegister/
  async getEmployeeQualifications(serviceNo) {
    try {
      const response = await axios.get("/UserDetails/GetEmployeeQualifications", {
        params: { serviceNo: serviceNo },
      });
      console.log("getEmployeeQualifications RAW RESPONSE:", JSON.stringify(response.data));
      return response.data;
    } catch (error) {
      console.error("Error Fetching Employee Qualifications", error);
      throw error;
    }
  },

  // FIXED: /UserDetails/ not /UserRegister/
  async getEmployeeDependents(serviceNo) {
    try {
      const response = await axios.get("/UserDetails/GetEmployeeDependents", {
        params: { serviceNo: serviceNo },
      });
      console.log("getEmployeeDependents RAW RESPONSE:", JSON.stringify(response.data));
      return response.data;
    } catch (error) {
      console.error("Error Fetching Employee Dependents", error);
      throw error;
    }
  },

  // FIXED: /UserDetails/ not /UserRegister/
  async getWorkplaceRelationships(serviceNo) {
    try {
      const response = await axios.get("/UserDetails/GetWorkplaceRelationships", {
        params: { serviceNo: serviceNo },
      });
      console.log("getWorkplaceRelationships RAW RESPONSE:", JSON.stringify(response.data));
      return response.data;
    } catch (error) {
      console.error("Error Fetching Workplace Relationships", error);
      throw error;
    }
  },

  // FIXED: /UserDetails/ not /UserRegister/
  async getPreviousEmployment(serviceNo) {
    try {
      const response = await axios.get("/UserDetails/GetPreviousEmployment", {
        params: { serviceNo: serviceNo },
      });
      console.log("getPreviousEmployment RAW RESPONSE:", JSON.stringify(response.data));
      return response.data;
    } catch (error) {
      console.error("Error Fetching Previous Employment", error);
      throw error;
    }
  },
};

export default EmployeeRegisterService;